import type { ElementType, HTMLAttributes, ReactNode } from 'react'

import styles from './Text.module.css'

/**
 * Роли текста. Не размеры.
 *
 * Это принципиально: `<Text variant="title-l">` переживёт решение сделать
 * заголовки на два пикселя крупнее, а `<Text size={24}>` — нет. Размеры
 * живут в шкале (scales.css), здесь только назначение.
 */
export type TextVariant =
  | 'display-l'
  | 'display-m'
  | 'title-l'
  | 'title-m'
  | 'title-s'
  | 'body-l'
  | 'body-m'
  | 'body-s'
  | 'label-l'
  | 'label-m'
  | 'overline'
  | 'caption'
  | 'numeric-l'
  | 'numeric-m'

export type TextTone = 'primary' | 'secondary' | 'tertiary' | 'accent' | 'sacred' | 'danger'

export interface TextProps extends Omit<HTMLAttributes<HTMLElement>, 'color'> {
  variant?: TextVariant
  tone?: TextTone
  /** Какой тег отрисовать. Внешний вид от этого не зависит — это про семантику. */
  as?: ElementType
  /** Ограничить меру строки. Для длинного текста читаемость важнее ширины экрана. */
  measure?: boolean
  children?: ReactNode
}

export function Text({
  variant = 'body-l',
  tone = 'primary',
  as: Tag = 'p',
  measure = false,
  className,
  ...rest
}: TextProps) {
  const classes = [
    styles.text,
    styles[`v-${variant}`],
    styles[`t-${tone}`],
    measure ? styles.measure : null,
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return <Tag className={classes} {...rest} />
}
